import { render, staticRenderFns } from "./SchoolTeachersAppraisal.vue?vue&type=template&id=518b0704&scoped=true&"
import script from "./SchoolTeachersAppraisal.vue?vue&type=script&lang=js&"
export * from "./SchoolTeachersAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeachersAppraisal.vue?vue&type=style&index=0&id=518b0704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b0704",
  null
  
)

export default component.exports